import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-promo-stacks-top-bar',
	templateUrl: './promo-stacks-top-bar.component.html',
	styleUrls: ['./promo-stacks-top-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class PromoStacksTopBarComponent {
	@Input() user;

	public open = false;

	constructor(
		private router: Router,
	) { }

	promosStacks() {
		if (this.user) {
			this.router.navigate([`/author-dashboard/${this.user.authorLink}/promo-stacks`]).then();
			return;
		}

		this.router.navigate(['/promo-stacks']).then();
	}
}
